import React, { useEffect, useState } from "react";
import { Link, useParams, withRouter } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { PaymentService } from "../../service/PaymentService";
import { SystemConfigService } from "../../service/configService";
import { ConvertDateFormat } from "../../components/ConvertDateFormat";
import { Pagination } from "react-bootstrap";
const { SearchBar } = Search;

const StorePaymentHistories = () => {
  let { store_id } = useParams();
  const [store, setStore] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPaymentHistories = (page = 1) => {
    setLoading(true);
    PaymentService.getPaymentHistories(store_id, page, 50)
      .then((response) => {
        console.log("Paginated response:", response.data);
        const paginatedData = response.data.data;
        const paymentData = paginatedData.data || [];
        
        let PaymentResArray = [];
        paymentData.map((res, index) => {
          return PaymentResArray.push({
            id: res.id,
            payrollEmployeeId: res.payrollEmployeeId,
            firstName: res.firstName,
            lastName: res.lastName,
            amount: res.amount,
            reportDate: ConvertDateFormat(res.reportDate),
            allocationDate: ConvertDateFormat(res.allocationDate),
            message: res.message,
            status: res.status,
          });
        });
        setPaymentHistory(PaymentResArray);
        setPaginationData({
          currentPage: paginatedData.current_page,
          lastPage: paginatedData.last_page,
          perPage: paginatedData.per_page,
          total: paginatedData.total,
          from: paginatedData.from,
          to: paginatedData.to
        });
        setCurrentPage(paginatedData.current_page);
      })
      .catch((error) => {
        console.log(error.response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPaymentHistories(1);

    SystemConfigService.getStore(store_id)
      .then((response) => {
        console.log(response.data.data);
        setStore(response.data.data);
      })
      .catch((error) => {
        console.log(error.response.data.message);
        // cogoToast.error(error.response.data.message, toastoptions);
      });
  }, [store_id]);

  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= (paginationData?.lastPage || 1)) {
      fetchPaymentHistories(page);
    }
  };

  const renderPagination = () => {
    if (!paginationData || paginationData.lastPage <= 1) return null;

    const pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(paginationData.lastPage, startPage + maxPagesToShow - 1);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {paginationData.from} to {paginationData.to} of {paginationData.total} entries
        </div>
        <Pagination>
          <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
          
          {startPage > 1 && <Pagination.Ellipsis disabled />}
          
          {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(page => (
            <Pagination.Item
              key={page}
              active={page === currentPage}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </Pagination.Item>
          ))}
          
          {endPage < paginationData.lastPage && <Pagination.Ellipsis disabled />}
          
          <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === paginationData.lastPage} />
          <Pagination.Last onClick={() => handlePageChange(paginationData.lastPage)} disabled={currentPage === paginationData.lastPage} />
        </Pagination>
      </div>
    );
  };

  const columns = [
    {
      dataField: "payrollEmployeeId",
      text: "Employee Id",
      sort: true,
    },
    {
      dataField: "firstName",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "lastName",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
    },
    {
      dataField: "reportDate",
      text: "Report Date",
      sort: true,
    },
    {
      dataField: "allocationDate",
      text: "Allocation Date",
      sort: true,
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: () => {
        return <label className="badge badge-success">Completed</label>;
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">
          <span style={{ textTransform: "capitalize" }}>Payments</span>
        </h3>

        <div>
          <Link to={"/financials/payment-history"}>
            <button className="btn btn-primary">
              View All Payments Histories
            </button>
          </Link>
        </div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/financials/payment-history">
                <span style={{ textTransform: "capitalize" }}>
                  {" "}
                  {store ? store.name : ""}
                </span>
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              <span style={{ textTransform: "capitalize" }}>
                Payments Histories
              </span>
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            {paymentHistory && (
              <div className="card-body">
                <h4 className="card-title"> Payments History</h4>
                <div className="row">
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={paymentHistory}
                      columns={columns}
                      search
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                    {renderPagination()}
                  </div>
                </div>
              </div>
            )}
            {loading && (
              <div className="text-center mt-3 mb-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(StorePaymentHistories);
